<div [formGroup]="parentForm">
  <div formGroupName="anamnesisVitae">
<!--    <div class="grid grid-cols-[200px_1fr] items-center gap-2 mb-6">-->
<!--      <label class="text-sm text-gray-700">შესაძლებლობის შეზღუდვის სტატუსი</label>-->
<!--      <nz-select formControlName="disabilityStatus" nzAllowClear nzPlaceHolder="აირჩიეთ">-->
<!--        @for (disability of disabilityStatus; track disability.value) {-->
<!--          <nz-option [nzLabel]="disability.alias" [nzValue]="disability.value"></nz-option>-->
<!--        }-->
<!--      </nz-select>-->
<!--    </div>-->

    <!-- 1. გადატანილი დაავადებები /ICD10/ -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">გადატანილი დაავადებები /ICD10/</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addDisease()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="diseaseHistory">
        @for (disease of diseaseHistory.controls; track 'disease' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_100px_1fr_36px] gap-2 mb-2">
            <nz-tree-select
              formControlName="icd10Id"
              [nzNodes]="classificationICDCodes()"
              nzShowSearch
              nzPlaceHolder="ICD კოდი"
              nzVirtualHeight="300px"
              nzHideUnMatched="true"
              nzCheckStrictly="true"
              nzShowLine="true"
              class="min-w-0"
            ></nz-tree-select>
            <input nz-input formControlName="year" placeholder="წელი" />
            <input nz-input formControlName="doctorClarification" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeDisease($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 2. გადატანილი ქირურგიული ჩარევები /NSCP/ -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">გადატანილი ქირურგიული ჩარევები /NSCP/</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addSurgicalIntervention()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="surgicalInterventions">
        @for (item of surgicalInterventions.controls; track 'surgical' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_100px_1fr_36px] gap-2 mb-2">
            <nz-tree-select
              formControlName="ncspId"
              [nzNodes]="classificationNCSPCodes()"
              nzShowSearch
              nzPlaceHolder="NSCP კოდი"
              nzVirtualHeight="300px"
              nzHideUnMatched="true"
              nzCheckStrictly="true"
              nzShowLine="true"
              class="min-w-0"
            ></nz-tree-select>
            <input nz-input formControlName="year" placeholder="წელი" />
            <input nz-input formControlName="doctorComment" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeSurgicalIntervention($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 3. ქრონიკული დაავადებები -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">ქრონიკული დაავადებები</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addChronicalDisease()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="chronicalDiseases">
        @for (item of chronicalDiseases.controls; track 'chronical' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_100px_1fr_36px] gap-2 mb-2">
            <nz-tree-select
              formControlName="icd10Id"
              [nzNodes]="classificationICDCodes()"
              nzShowSearch
              nzPlaceHolder="ICD კოდი"
              nzVirtualHeight="300px"
              nzHideUnMatched="true"
              nzCheckStrictly="true"
              nzShowLine="true"
              class="min-w-0"
            ></nz-tree-select>
            <input nz-input formControlName="year" placeholder="წელი" />
            <input nz-input formControlName="doctorClarification" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeChronicalDisease($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 4. სისხლის გადასხმები -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">სისხლის გადასხმები</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addTransfusion()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="transfusions">
        @for (item of transfusions.controls; track 'transfusion' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_100px_1fr_36px] gap-2 mb-2">
            <nz-select formControlName="bloodComponent" nzPlaceHolder="სისხლის კომპონენტი" nzAllowClear>
              @for (blood of bloodComponents; track blood.value) {
                <nz-option [nzLabel]="blood.value" [nzValue]="blood.id"></nz-option>
              }
            </nz-select>
            <input nz-input formControlName="transfDate" placeholder="წელი" />
            <input nz-input formControlName="doctorComment" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeTransfusion($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 5. იმუნიზაცია -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">იმუნიზაცია</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addImmunization()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="immunization">
        @for (item of immunization.controls; track 'immunization' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_100px_1fr_36px] gap-2 mb-2">
            <nz-select formControlName="yAxisID" nzPlaceHolder="იმუნიზაციის ტიპი" nzAllowClear>
              @for (type of immunizationTypes; track type.value) {
                <nz-option [nzLabel]="type.value" [nzValue]="type.id"></nz-option>
              }
            </nz-select>
            <input nz-input formControlName="dateOfInnection" placeholder="წელი" />
            <input nz-input formControlName="vaccineName" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeImmunization($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 6. მედიკამენტები ალერგია -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">მედიკამენტები ალერგია</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addAllergyDrug()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="alergiesDrugs">
        @for (disease of alergiesDrugs.controls; track 'alergiesDrugs' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_1fr_1fr_36px] gap-2 mb-2">
            <div>
              <nz-input-group nzSearch [nzAddOnAfter]="suffixBtn">
                <input type="text" nz-input placeholder="მედიკამენტი" [value]="(disease.get('drugId')?.value || '') +' '+ (disease.get('drugName')?.value || '')"/>
              </nz-input-group>
              <ng-template #suffixBtn>
                <button nz-button nzType="primary" nzSearch (click)="chooseDrug(disease)">ძებნა</button>
              </ng-template>
            </div>
            <nz-select formControlName="drugComponent" nzPlaceHolder="კომპონენტის ტიპი" nzAllowClear>
              @for (drugComponent of drugComponents; track drugComponent.value) {
                <nz-option [nzLabel]="drugComponent.value" [nzValue]="drugComponent.id"></nz-option>
              }
            </nz-select>
            <input nz-input formControlName="comment" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeAllergyDrug($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 7. სხვა ალერგია -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">სხვა ალერგია</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addOtherAllergy()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="otherAllergiesAndReactions">
        @for (item of otherAllergiesAndReactions.controls; track 'otherAllergy' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_36px] gap-2 mb-2">
            <input nz-input formControlName="comment" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeOtherAllergy($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- 8. სკრინინგი -->
    <div class="mb-5">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-sm font-semibold text-red-600">სკრინინგი</span>
        <button nz-button nzType="primary" nzSize="small" nzShape="circle" (click)="addScreening()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
      <div formArrayName="screening">
        @for (item of screening.controls; track 'screening' + $index) {
          <div [formGroupName]="$index" class="grid grid-cols-[1fr_140px_100px_1fr_36px] gap-2 mb-2">
            <nz-select formControlName="screeningType" nzPlaceHolder="სკრინინგის სახეობა" nzAllowClear>
              @for (st of screeningTypes; track st.id) {
                <nz-option [nzLabel]="st.value" [nzValue]="st.id"></nz-option>
              }
            </nz-select>
            <nz-select formControlName="screeningResult" nzPlaceHolder="რეზულტატი" nzAllowClear>
              <nz-option nzLabel="დადებითი" [nzValue]="1"></nz-option>
              <nz-option nzLabel="უარყოფითი" [nzValue]="2"></nz-option>
              <nz-option nzLabel="საეჭვო" [nzValue]="3"></nz-option>
            </nz-select>
            <input nz-input formControlName="screeningDate" placeholder="წელი" />
            <input nz-input formControlName="doctorClarification" placeholder="ექიმის მიერ დაზუსტება" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeScreening($index)">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
